import { get, post } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;
const facilitiesURL = url + "/LeasingFacilities";

const getFacilityHeader = (documentId, siteId) => get(`${facilitiesURL}/${documentId}/${siteId}/header`);

const getFacilityReports = (documentId, siteId) => {
  return post(`${url}/reports/document-reports`, { documentId, siteId });
};

const generateDocumentReport = report => post(`${url}/reports/generate-document-report`, report);

const restartOrRenewFacility = (documentId, siteId, offerId, offerSiteId, isRenewal) =>
  post(`${facilitiesURL}/${documentId}/${siteId}/restartOrRenewFacility`, {
    documentId,
    siteId,
    offerId,
    offerSiteId,
    isRenewal
  });

const exp = {
  getFacilityHeader,
  getFacilityReports,
  generateDocumentReport,
  restartOrRenewFacility
};
export default exp;
